import { createContext, useContext } from 'react';

import { type TrackingContextType } from './types';

const TrackingContext = createContext<TrackingContextType>(
  {} as TrackingContextType
);

const useTrackingContext = () => {
  const context = useContext(TrackingContext);
  if (!context) {
    throw new Error(
      'useTrackingContext must be used within a TrackingContextProvider'
    );
  }
  return context;
};

export { TrackingContext, useTrackingContext };
